import { ZIcon } from "components/ZIcon";
import { ZIconType } from "helpers/utility/iconMap";
import { useEffect, useState } from "react";
import freedomLogo from "assets/freedom_logo.svg";
import freedomLogoSmall from "assets/freedom_logo_nocolour_notext.svg";
import { ZButton } from "components/ZButton";

interface LoginRedirectProps {}

export function LoginRedirect(props: LoginRedirectProps) {
	const newUrl = "https://zfreedom.com.au";
	const [count, setCount] = useState(5);
	useEffect(() => {
		const timer = setTimeout(() => {
			setCount((prev) => prev - 1);
			if (count <= 1) {
				window.location.href = newUrl;
			}
		}, 1000);
		return () => clearTimeout(timer);
	}, [count]);

	return (
		<div className="vh-100 d-flex">
			<div className="bg-primary w-100" style={{ maxWidth: "600px", width: "45%" }}>
				<div className="d-flex flex-column align-items-center justify-content-center text-white h-100 p-4" style={{ padding: "4rem" }}>
					<img src={freedomLogoSmall} alt="Freedom Logo" style={{ width: "4rem", height: "4rem", alignSelf: "flex-start" }} />

					<div className="flex-grow align-content-center text-center">
						<h1>
							An exciting new version of Z Freedom is here!
							<br />
							<br />
							You'll be automatically redirected to the new site in a few seconds
						</h1>
						<br />
						<h3>Redirecting in {count}...</h3>
						<br />
						<ZButton
							variant="secondary"
							onClick={() => {
								window.location.href = newUrl;
							}}
						>
							Go to new site now
						</ZButton>
					</div>
				</div>
			</div>
			<div className="d-none d-xl-flex flex-column flex-grow-1 position-relative justify-content-center align-items-center px-3">
				<img src={freedomLogo} alt="Freedom Logo" className="px-3" style={{ maxWidth: "100%", paddingLeft: "6rem", paddingRight: "6rem" }} />
				<div className="position-absolute" style={{ bottom: "1.5rem", left: 0, right: 0, paddingLeft: "3rem", paddingRight: "3rem" }}>
					<div className="d-flex justify-content-around flex-wrap gap-3">
						<PhoneInfo />
						<EmailInfo />
						<WebsiteInfo />
					</div>
				</div>
			</div>
		</div>
	);
}

const PhoneInfo = () => {
	return (
		<div className="d-inline-flex align-items-center gap-2">
			<ZIcon icon={ZIconType.Phone} iconClassName="text-primary" />
			<a href="tel:+61285439944">(02) 8543 9944</a>&nbsp;|&nbsp;<a href="tel:+61399880772">(03) 9988 0772</a>&nbsp;|&nbsp;<a href="tel:+61730541277">(07) 3054 1277</a>
		</div>
	);
};

const EmailInfo = () => {
	return (
		<div className="d-inline-flex align-items-center gap-2">
			<ZIcon icon={ZIconType.Mail} iconClassName="text-primary" />
			<a href="mailto:zfreedom@zfreedom.com.au">zfreedom@zfreedom.com.au</a>
		</div>
	);
};

const WebsiteInfo = () => {
	return (
		<div className="d-inline-flex align-items-center gap-2">
			<ZIcon icon={ZIconType.Globe} iconClassName="text-primary" />
			<a href="https://zsoftware.com.au/z-freedom/" target="_blank" rel="noopener noreferrer">
				https://zsoftware.com.au/z-freedom/
			</a>
		</div>
	);
};
